export default class NotificationsBloc {
  constructor({ notificationsRepository }) {
    this.notificationsRepository = notificationsRepository;
  }

  get notifications$() {
    return this.notificationsRepository.notifications$;
  }

  get total$() {
    return this.notificationsRepository.total$;
  }

  updateSearchCriteria(updatedCriteria) {
    this.notificationsRepository.updateSearchCriteria(updatedCriteria);
  }

  readNotification(id) {
    this.notificationsRepository.readNotification(id);
  }

  readAllNotification() {
    this.notificationsRepository.readAllNotification();
  }

  dispose() {
    this.notificationsRepository.dispose();
  }
}
